export const operations = {
      update:{
        en:'update',
        ja:'更新'
      },
      register:{
        en:'register',
        ja:'登録'
      },
      delete:{
        en:'delete',
        ja:'削除'
      },
    }


